// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchInputDark_container__2SUKb","input":"SearchInputDark_input__sI7MN"};